import React from 'react';
import AmplifyAuthScreen from './AmplifyAuthScreen';

// const originalCreateElement= React.createElement;
//
// // Monkey-patch
// React.createElement = function (type, props, ...children) {
// 	if (typeof type === 'function' && (type.name === 'SsoAuth' || type.displayName === 'SsoAuth')) {
// 		return originalCreateElement(AmplifyAuthScreen, props, ...children);
// 	}
// 	return originalCreateElement(type, props, ...children);
// };

/**
 * JS represents application entry point with specification of module dependencies.
 */
import {FOEDUS_ROLE, organOfferIdByEnv} from './domain/constants';

// import css and images (important for webpack)
// let env = globalParams.environment;
const isProd = window.location.hostname.includes('portal.foedus-eoeo.eu') || window.location.hostname.includes('auth.foedus-eoeo.eu');
if (isProd) {
	import(/* webpackChunkName: "prod" */ '../css/prod.css');
} else {
	import(/* webpackChunkName: "test" */ '../css/test.css');
}
import '../images/icon.ico';
import '../images/icon.png';

import {getStore, SwAction} from 'simplifyworks-core-ui';
import { Route } from 'react-router';
// Docasne zakomentovane kym sa test chova ako prod kvoli mailom
// import pcLogo from '../images/pc-logo.png';
// import mobileLogo from '../images/mobile-logo.png';
import testLogo from '../images/app-test-logo.png';
import { TbHeartPlus, TbHeartMinus, TbArrowsRightLeft } from 'react-icons/tb';
import { RiMailSettingsFill } from 'react-icons/ri';
import { VscFiles } from 'react-icons/vsc';
import { MdViewQuilt, MdList, MdSettings } from 'react-icons/md';
import oodFoedusLogo from '../images/ood-foedus.png';
let oodFoedusLogoImg = oodFoedusLogo;
if (oodFoedusLogo && oodFoedusLogo.search('{contextName}') !== -1) {
	oodFoedusLogoImg = oodFoedusLogo.replace('{contextName}', globalParams.contextName + '/');
}

// Docasne kym sa test chova ako prod kvoli mailom
const header = {
	pc: { logo: isProd ? testLogo : testLogo, height: 75 },
	tablet: { logo: isProd ? testLogo : testLogo },
	mobile: { logo: isProd ? testLogo : testLogo }
};

import Template from './template';
import { init, SwList } from 'simplifyworks-core-ui';
import hd from 'simplifyworks-hd-ui';
import ood from 'simplifyworks-ood-ui';
import poll from 'simplifyworks-poll-ui';
import dog from 'simplifyworks-dog-ui';
import push from 'simplifyworks-push-ui';
import df from 'simplifyworks-dynamic-fields-ui';
//import fs from 'simplifyworks-financing-sources-ui';
import cpd from 'simplifyworks-cpd-ui';
import ext from 'simplifyworks-ext-ui';
import contacts from './module/contacts';
import cognito from './module/cognito';
import statistics from './module/statistics';
import FoedusNewOrganOfferPortlet from './views/portlets/FoedusNewOrganOfferPortlet';
import FoedusTemporaryUserOrganOffersPortlet from './views/portlets/FoedusTemporaryUserOrganOffersPortlet';
import FoedusConversion from './FoedusConversion';
import localization from './localization';
import {
	openAcceptOrganOfferModal,
	openAddMultipleOrganOffersModal,
	openDeclineOrganOfferModal,
	openGrantAnonymousAccessModal,
	openMessageModal,
	openNotificationModal
} from './redux/actions/foedus';
import foedusReducer from './redux/reducers/foedus';
import { FaPlus } from 'react-icons/fa';
import { BiCheckCircle, BiXCircle, BiGlobe } from 'react-icons/bi';
import { MdNotifications, MdMessage } from 'react-icons/md';
import i18n from 'i18next';
import { Amplify } from 'aws-amplify';
import { authConfig } from './amplify-config';
import 'aws-amplify/auth/enable-oauth-listener';

Amplify.configure({
	Auth: {
		Cognito: {
			userPoolId: authConfig.userPoolId,
			userPoolClientId: authConfig.clientId,
			loginWith: {
				oauth: {
					domain: authConfig.domain,
					scopes: authConfig.scopes,
					redirectSignIn: [authConfig.redirectSignInUri],
					redirectSignOut: [authConfig.redirectSignOutUri],
					responseType: authConfig.responseType
				}
			}
		}
	}
});

// Sluzi na zobrazenie vlastneho systemMenu - polozka "My account"
const foedusSystemMenuModule = {
	name: 'foedus-system-menu-module',
	key: 'foedus',
	shortLabelKey: 'foedus',
	systemMenu: {
		'my-account': {
			label: i18n.t('foedus-my-account'),
			labelKey: 'foedus-my-account',
			path: '/contacts/my-account'
		}
	},
	localization: {},
	routes: [],
	portlets: [],
	reducers: {}
};

let modules = [ood, poll, dog, df, cpd, ext, push, contacts, cognito];

if (!isProd) {
	modules.push(statistics);
}

let systemModules = [hd, foedusSystemMenuModule];
delete ood.menu.oodDocumentList;

ood.portlets = [
	<FoedusNewOrganOfferPortlet identifier='foedus-new-organ-offer-portlet' />,
	<FoedusTemporaryUserOrganOffersPortlet identifier='foedus-temporary-user-organ-offers-portlet' />
];

ood.reducers.foedus = foedusReducer;

// init application with specified modules and customization
init({
	Template,
	systemModules,
	modules,
	header,
	languages: ['en'],
	customization: {
		auth: () => <AmplifyAuthScreen/>,
		localization
	}
});

// customizace základní úrovně levého menu
cpd.icon = VscFiles;
ood.icon = isProd ? TbHeartPlus : oodFoedusLogoImg;

// odstranit menu HD, ale nechat CAT
hd.removeQuestionsMenuItem();
// hd.addTasksMenuItem();

ood.menu.oodSitemap = {
	icon: MdViewQuilt,
	labelKey: 'ood-menu-sitemap',
	path: '/ood/entries-sitemap',
	rolesAllowed: ['ood_admin']
};

ood.menu.oodEntryList = {
	icon: MdList,
	labelKey: 'ood-menu-entries',
	path: '/ood/entries',
	rolesAllowed: ['ood_admin']
};

//Definice
ood.menu.oodDefinitionList = {
	icon: MdSettings,
	labelKey: 'ood-menu-definitions',
	path: '/ood/definitions',
	rolesAllowed: ['ood_admin']
};

const ORGAN_OFFER_DEFINITION_GUID = '3a48d966-c14c-4351-850b-1a50ba01d9d9';

ood.menu.organy = {
	icon: TbHeartPlus,
	labelKey: 'ood-menu-organy',
	path: '/ood/entries-by-definition/' + organOfferIdByEnv[globalParams.hostName],
	rolesAllowed: [FOEDUS_ROLE.COORDINATOR, 'ood_user']
};

const organRequestIdByEnv = {
	'http://localhost:8084': 62036,
	'https://foedus-dev.ders.cz': 62036,
	'https://foedus-test.ders.cz': 26236,
	'https://foedus.cz': 0
};

if (!isProd) {
	ood.menu.organRequests = {
		icon: TbHeartMinus,
		labelKey: 'ood-menu-organ-requests',
		path: '/ood/entries-by-definition/' + organRequestIdByEnv[globalParams.hostName],
		rolesAllowed: [FOEDUS_ROLE.ADMIN]
	};
}

const notificationGroupsIdByEnv = {
	'http://localhost:8084': 172856,
	'https://foedus-dev.ders.cz': 172856,
	'https://foedus-test.ders.cz': 89384,
	'https://staging.foedus-eoeo.eu': 25287,
	'https://portal.foedus-eoeo.eu': 27318
};

const ORGAN_OFFER_GUID = '3a48d966-c14c-4351-850b-1a50ba01d9d9';
const ACCEPT_ORGAN_OFFER_GUID = 'a367e9d5-c775-424b-a0ba-ced41bb7f315';
const DECLINE_ORGAN_OFFER_GUID = '080c2a41-4f09-458b-81ef-69aa5a54e1ce';

ood.menu.notificationGroups = {
	icon: RiMailSettingsFill,
	labelKey: 'ood-menu-notification-groups',
	path: '/ood/entries-by-definition/' + notificationGroupsIdByEnv[globalParams.hostName],
	rolesAllowed: [FOEDUS_ROLE.COUNTRY_MANAGER, FOEDUS_ROLE.ADMIN]
};

ood.menu.conversion = {
	icon: TbArrowsRightLeft,
	labelKey: 'ood-menu-conversion',
	path: '/conversion',
	rolesAllowed: [FOEDUS_ROLE.COORDINATOR]
};

ood.routes = ood.routes.concat(
	<Route exact path={'/conversion'} key={'foedus-conversion'} components={FoedusConversion} rolesAllowed={[FOEDUS_ROLE.COORDINATOR]} />
);

ood.getActionsForEntryListByDefinition = ({definitionGuid}) => {
	if (!definitionGuid) {
		return [];
	}

	const state = getStore()?.getState();
	const allUserRoles = state?.security?.allRoles ?? [];
	const hasFoedusRole = [FOEDUS_ROLE.ADMIN, FOEDUS_ROLE.COUNTRY_MANAGER, FOEDUS_ROLE.COORDINATOR]
		.some(role => allUserRoles.includes(role));
	const isFoedusAdmin = [FOEDUS_ROLE.ADMIN]
		.some(role => allUserRoles.includes(role));

	if (
		definitionGuid === ORGAN_OFFER_DEFINITION_GUID
		&& (hasFoedusRole || isFoedusAdmin)
	) {
		return [
			<SwList.Action
				key='add-multiple-organ-offer'
				variant='success'
				isEnabled={() => true}
				labelKey='foedus-add-multiple-organ-offer'
				icon={FaPlus}
				execute={() => {
					getStore().dispatch(openAddMultipleOrganOffersModal());
				}}
			/>
		];
	}
};

ood.getActionsForEntryDetail = (data) => {
	const {definitionGuid} = data;

	if (!definitionGuid) {
		return [];
	}

	let additionalActions = [];

	if (definitionGuid === ORGAN_OFFER_GUID) {

		// if (
		// 	getStore().getState()?.security?.allRoles?.some(role =>
		// 		[FOEDUS_ROLE.COORDINATOR, FOEDUS_ROLE.COUNTRY_MANAGER, FOEDUS_ROLE.ADMIN].includes(role))
		// ) {
		// 	additionalActions.push((
		// 		<SwAction
		// 			displayType='inline-full'
		// 			getOptions={() => ({
		// 				onClick: () => {
		// 					getStore().dispatch(openChangeRecipientsModal());
		// 				},
		// 				labelKey: 'foedus-change-recipient-groups',
		// 				icon: BiGroup
		// 			})}
		// 		/>
		// 	));
		// }

		if (
			getStore().getState()?.foedus?.showNotificationActionButton // Pre vsetkych koordinatorov nabizejici organizace
		) {
			additionalActions.push((
				<SwAction
					displayType='inline-full'
					getOptions={() => ({
						onClick: () => {
							getStore().dispatch(openNotificationModal());
						},
						labelKey: 'foedus-notification-title',
						className: 'foedus-notification-btn',
						icon: MdNotifications
					})}
				/>
			));
		}

		if (
			getStore().getState()?.foedus?.showMessageActionButton // Pre vsetkych okrem koordinatorov nabizejici organizace
		) {
			additionalActions.push((
				<SwAction
					displayType='inline-full'
					getOptions={() => ({
						onClick: () => {
							getStore().dispatch(openMessageModal());
						},
						labelKey: 'foedus-message-title',
						className: 'foedus-message-btn',
						icon: MdMessage
					})}
				/>
			));
		}

		if (
			getStore().getState()?.foedus?.showGrantAnonymousAccessActionButton // Zobrazujeme len ak je organ offec active
		) {
			additionalActions.push((
				<SwAction
					displayType='inline-full'
					getOptions={() => ({
						onClick: () => {
							getStore().dispatch(openGrantAnonymousAccessModal());
						},
						labelKey: 'foedus-grant-anonymous-access',
						icon: BiGlobe
					})}
				/>
			));
		}
	}

	return {
		additionalActions,
		replaceCreateSubDefinitionBtnByGuid: {
			[ACCEPT_ORGAN_OFFER_GUID]: (
				<SwAction
					displayType='inline-full'
					getOptions={() => ({
						onClick: () => {
							getStore().dispatch(openAcceptOrganOfferModal());
						},
						labelKey: 'foedus-accept-organ-offer',
						variant: 'info',
						className: 'accept-organ-offer-btn',
						icon: BiCheckCircle
					})}
				/>
			),
			[DECLINE_ORGAN_OFFER_GUID]: (
				<SwAction
					displayType='inline-full'
					getOptions={() => ({
						onClick: () => {
							getStore().dispatch(openDeclineOrganOfferModal());
						},
						labelKey: 'foedus-decline-organ-offer',
						variant: 'danger',
						className: 'decline-organ-offer-btn',
						icon: BiXCircle
					})}
				/>
			)
		}
	};
};
